import * as React from 'react';
const SvgCards = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={240}
    height={240}
    fill="none"
    viewBox="0 0 240 240"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#E0EBFF"
        d="M120 240c66.274 0 120-53.726 120-120S186.274 0 120 0 0 53.726 0 120s53.726 120 120 120"
      />
      <g filter="url(#b)" opacity={0.5}>
        <path
          fill="#0014CC"
          d="M186 57H54a9 9 0 0 0-9 9v40.5a9 9 0 0 0 9 9h132a9 9 0 0 0 9-9V66a9 9 0 0 0-9-9"
        />
      </g>
      <path
        fill="#fff"
        d="M45 58.5a9 9 0 0 1 9-9h132a9 9 0 0 1 9 9v48a9 9 0 0 1-9 9H54a9 9 0 0 1-9-9z"
      />
      <path
        fill="#0014CC"
        d="M96 58.5H60a6 6 0 0 0-6 6v36a6 6 0 0 0 6 6h36a6 6 0 0 0 6-6v-36a6 6 0 0 0-6-6"
      />
      <path
        fill="#85A3FF"
        d="M145.5 60h-33a1.5 1.5 0 0 0-1.5 1.5v6a1.5 1.5 0 0 0 1.5 1.5h33a1.5 1.5 0 0 0 1.5-1.5v-6a1.5 1.5 0 0 0-1.5-1.5"
      />
      <path
        fill="#E0EBFF"
        d="M120 102a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0M145.5 97.5h-21A1.5 1.5 0 0 0 123 99v6a1.5 1.5 0 0 0 1.5 1.5h21a1.5 1.5 0 0 0 1.5-1.5v-6a1.5 1.5 0 0 0-1.5-1.5M184.5 75h-72a1.5 1.5 0 0 0-1.5 1.5v6a1.5 1.5 0 0 0 1.5 1.5h72a1.5 1.5 0 0 0 1.5-1.5v-6a1.5 1.5 0 0 0-1.5-1.5"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M78 72.85a.9.9 0 0 1 .805.498l2.542 5.083 6.04.93a.9.9 0 0 1 .5 1.525l-4.178 4.178.93 6.05a.9.9 0 0 1-1.305.934L78 89.265l-5.334 2.783a.9.9 0 0 1-1.305-.935l.93-6.049-4.177-4.177a.9.9 0 0 1 .5-1.526l6.04-.93 2.541-5.084A.9.9 0 0 1 78 72.85m0 2.913-1.945 3.89a.9.9 0 0 1-.668.487l-4.745.73 3.245 3.244a.9.9 0 0 1 .253.773l-.73 4.743 4.174-2.178a.9.9 0 0 1 .832 0l4.174 2.178-.73-4.743a.9.9 0 0 1 .254-.773l3.244-3.245-4.745-.73a.9.9 0 0 1-.668-.486z"
        clipRule="evenodd"
      />
      <g filter="url(#c)" opacity={0.5}>
        <path
          fill="#0014CC"
          d="M186 132H54a9 9 0 0 0-9 9v40.5a9 9 0 0 0 9 9h132a9 9 0 0 0 9-9V141a9 9 0 0 0-9-9"
        />
      </g>
      <path
        fill="#fff"
        d="M45 133.5a9 9 0 0 1 9-9h132a9 9 0 0 1 9 9v48a9 9 0 0 1-9 9H54a9 9 0 0 1-9-9z"
      />
      <path
        fill="#0014CC"
        d="M96 133.5H60a6 6 0 0 0-6 6v36a6 6 0 0 0 6 6h36a6 6 0 0 0 6-6v-36a6 6 0 0 0-6-6"
      />
      <path
        fill="#85A3FF"
        d="M145.5 135h-33a1.5 1.5 0 0 0-1.5 1.5v6a1.5 1.5 0 0 0 1.5 1.5h33a1.5 1.5 0 0 0 1.5-1.5v-6a1.5 1.5 0 0 0-1.5-1.5"
      />
      <path
        fill="#E0EBFF"
        d="M120 177a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0M145.5 172.5h-21a1.5 1.5 0 0 0-1.5 1.5v6a1.5 1.5 0 0 0 1.5 1.5h21a1.5 1.5 0 0 0 1.5-1.5v-6a1.5 1.5 0 0 0-1.5-1.5M184.5 150h-72a1.5 1.5 0 0 0-1.5 1.5v6a1.5 1.5 0 0 0 1.5 1.5h72a1.5 1.5 0 0 0 1.5-1.5v-6a1.5 1.5 0 0 0-1.5-1.5"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M78 147.85a.9.9 0 0 1 .805.498l2.542 5.084 6.04.928a.899.899 0 0 1 .5 1.526l-4.178 4.177.93 6.05a.9.9 0 0 1-.365.868.9.9 0 0 1-.94.066L78 164.265l-5.334 2.782a.9.9 0 0 1-.94-.066.9.9 0 0 1-.365-.868l.93-6.05-4.177-4.177a.9.9 0 0 1 .5-1.526l6.04-.928 2.541-5.084a.9.9 0 0 1 .805-.498m0 2.912-1.945 3.891a.9.9 0 0 1-.668.486l-4.745.73 3.245 3.245a.9.9 0 0 1 .253.773l-.73 4.742 4.174-2.177a.9.9 0 0 1 .832 0l4.174 2.177-.73-4.742a.9.9 0 0 1 .254-.773l3.244-3.245-4.745-.73a.9.9 0 0 1-.668-.486z"
        clipRule="evenodd"
      />
      <path
        fill="#0A2FFF"
        d="M213.969 122.543c.666-2.468 4.32-2.468 4.984 0l.349 1.294c.241.895.985 1.587 1.926 1.79l.725.157c2.678.579 2.678 4.238 0 4.817l-.725.157c-.941.203-1.685.894-1.926 1.79l-.349 1.293c-.664 2.468-4.318 2.468-4.984 0l-.348-1.293c-.241-.896-.985-1.587-1.926-1.79l-.726-.157c-2.677-.579-2.677-4.238 0-4.817l.726-.157c.941-.203 1.685-.895 1.926-1.79z"
      />
      <path fill="#85A3FF" d="M17.191 115.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
      <path fill="#C2D4FF" d="M26.191 103.5a6 6 0 1 0 0-12 6 6 0 0 0 0 12" />
      <path
        fill="#85A3FF"
        d="M111.508 18.235c.665-2.468 4.319-2.468 4.984 0l.349 1.294c.241.895.985 1.587 1.926 1.79l.726.157c2.677.579 2.677 4.238 0 4.817l-.726.157c-.941.203-1.685.894-1.926 1.79l-.349 1.293c-.665 2.468-4.319 2.468-4.984 0l-.348-1.293c-.242-.896-.985-1.587-1.927-1.79l-.725-.157c-2.677-.58-2.677-4.238 0-4.817l.725-.157c.942-.203 1.685-.895 1.927-1.79z"
      />
      <path fill="#0A2FFF" d="M130.5 37.961a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
      <path
        fill="#0A2FFF"
        fillRule="evenodd"
        d="M117.5 220.116a5 5 0 0 0 5-5.001 5 5 0 1 1-5 5.001m0 0a5 5 0 0 1 5-5.001 5 5 0 1 0-5 5.001"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <filter
        id="b"
        width={170}
        height={78.5}
        x={35}
        y={47}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur result="effect1_foregroundBlur_1_3" stdDeviation={5} />
      </filter>
      <filter
        id="c"
        width={170}
        height={78.5}
        x={35}
        y={122}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur result="effect1_foregroundBlur_1_3" stdDeviation={5} />
      </filter>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h240v240H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCards;
